import initializeAnimatedNumbers from './js/numbers-animated.js'
import initializeHeader from './js/initialize-header.js'
import './js/globals.js'

initializeAnimatedNumbers()
initializeHeader()
